import { SFG_GLOBALS } from './environment.sfg.globals';

export const environment = SFG_GLOBALS;

// Overwrite settings for this environment.
environment.name = 'test';
environment.apiConfiguration.baseUrl = 'https://api.test.sfg.digitalemenschen.dev';
environment.apiConfiguration.publicApiKey = '4418104748cc4d3a6c2c5d7b6e4485bbd994e61d';
environment.appUrls.workOffice = 'https://office.test.sfg.digitalemenschen.dev';
// SFG hat keine Website-App im Monorepo — es ist die externe Live-Site.
environment.appUrls.website = 'https://www.sfg-ag.ch';
environment.appUrls.freigabe = 'https://freigabe.test.sfg.digitalemenschen.dev';
environment.appUrls.app = 'https://app.test.sfg.digitalemenschen.dev';
environment.appUrls.geruestrechner = 'https://geruestrechner.test.sfg.digitalemenschen.dev';
environment.isLoggingEnabled.ngxs = true;
environment.isLoggingEnabled.logger = true;
environment.production = false;
environment.sentryDsn.app = 'https://923275e74e3444839c6954995f7957e0@bugs.digitalemenschen.dev/17';
environment.sentryDsn.office = 'https://b8f834ae5ffa4f24ad71fceacffdf60d@bugs.digitalemenschen.dev/13';
environment.sentryDsn.geruestrechner = 'https://6048bf425e694e1982ccd99fd43c081f@bugs.digitalemenschen.dev/9';
environment.googleMapApiKey = 'AIzaSyCz_WQ13DUqgawY2kxUejHhbqcJTqMCdB4';
